// extracted by mini-css-extract-plugin
module.exports = {"container--opened":"a10a3f92e9--container--opened--ox2KS"};